import api from '../utils/api';

/** GET /robot/map/blocks — blocks for robot; may embed floors when noBlock */
export function fetchMapBlocks(robotId, params = {}) {
  return api.get('/robot/map/blocks', {
    params: { robotId, ...params },
  });
}

/** GET /robot/map/floors — floors for one block */
export function fetchMapFloorsByBlock(blockId, params = {}) {
  return api.get('/robot/map/floors', {
    params: { blockId, ...params },
  });
}

/** GET /robot/map/floors/by-robot — floors when robot has no blocks */
export function fetchMapFloorsByRobot(robotId, params = {}) {
  return api.get('/robot/map/floors/by-robot', {
    params: { robotId, ...params },
  });
}

/** GET /robot/map/rooms — rooms on a floor */
export function fetchMapRooms(floorId, params = {}) {
  return api.get('/robot/map/rooms', {
    params: { floorId, ...params },
  });
}

/** DELETE /robot/map/room/delete */
export function deleteMapRoom(floorId, roomName) {
  return api.delete('/robot/map/room/delete', {
    params: { floorId, roomName },
  });
}
